import type { ProductCopyRequest, ProductCopyResponse } from './apiAdminProduct'
import { useApi } from '@shared/api'
import type { ExcludeIngredient, CreateExcludeDto, UpdateExcludeDto } from '@entities/product'

export const apiAdminExcludeIngredients = {
  async getAll(): Promise<ExcludeIngredient[]> {
    const { data } = await useApi(true, true).get<ExcludeIngredient[]>('/admin/excludes')
    return data
  },

  /**
   * Копия отбавки в другой филиал: переносит название, описание и картинки.
   * Модификаторов у отбавки нет, поэтому отчёт сопоставления в ответе всегда пустой.
   */
  async copy(id: number, payload: ProductCopyRequest): Promise<ProductCopyResponse> {
    const { data } = await useApi(true, true).post<ProductCopyResponse>(`/admin/excludes/${id}/copy`, { body: payload })
    return data
  },

  async getById(id: number): Promise<ExcludeIngredient> {
    const { data } = await useApi(true, true).get<ExcludeIngredient>(`/admin/excludes/${id}`)
    return data
  },

  async create(payload: CreateExcludeDto): Promise<ExcludeIngredient> {
    const { data } = await useApi(true, true).post<ExcludeIngredient>('/admin/excludes', { body: payload })
    return data
  },

  async updateFull(id: number, payload: CreateExcludeDto): Promise<ExcludeIngredient> {
    const { data } = await useApi(true, true).put<ExcludeIngredient>(`/admin/excludes/${id}`, { body: payload })
    return data
  },

  async update(id: number, payload: UpdateExcludeDto | FormData): Promise<ExcludeIngredient> {
    const { data } = await useApi(true, true).patch<ExcludeIngredient>(`/admin/excludes/${id}`, { body: payload })
    return data
  },

  async delete(id: number): Promise<{ message: string }> {
    const { data } = await useApi(true, true).delete<{ message: string }>(`/admin/excludes/${id}`)
    return data
  },

  async deleteImage(id: number, imageKey: string): Promise<{ message: string; remainingImages: number }> {
    const { data } = await useApi(true, true).delete<{ message: string; remainingImages: number }>(
      `/admin/excludes/${id}/img/${encodeURIComponent(imageKey)}`,
    )
    return data
  },
}

export default apiAdminExcludeIngredients
